// Page transition wrapper with simple fade animation
const PageTransition = ({ children }: { children: React.ReactNode }) => {
  return <div className="transition-opacity duration-300 animate-fade-in">{children}</div>;
};

export default PageTransition;
